import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './components/Login.vue';
import PageNotFound from './components/PageNotFound.vue';
import MachineComponent from './components/MachineComponent.vue';
import MicrocontrollerComponent from './components/MicrocontrollerComponent.vue';
import WeavingMachineComponent from './components/WeavingMachineComponent.vue';
import WeavingMachineStatisticComponent from './components/WeavingMachineStatisticComponent.vue';
import UserComponent from './components/UserComponent.vue';
import GroupComponent from './components/GroupComponent.vue';
import StatGraphComponent from './components/StatGraphComponent.vue';
import StatGraphRealtimeComponent from './components/StatGraphRealtimeComponent.vue';
import StatOverviewComponent from './components/StatOverviewComponent.vue';
import StatSummarizeComponent from './components/StatSummarizeComponent.vue';
import AnnotationComponent from './components/AnnotationComponent.vue';
import AnnotationFormComponent from './components/AnnotationFormComponent.vue';
import PreferencesComponent from './components/PreferencesComponent.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/preferences',
      name: 'preferences',
      component: PreferencesComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/weaving-machine/settings',
      name: 'weaving-machine-settings',
      component: WeavingMachineComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/weaving-machine/statistics',
      name: 'weaving-machine-statistics',
      component: WeavingMachineStatisticComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/stat/graph',
      name: 'stat-graph',
      component: StatGraphComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/stat/graph-realtime',
      name: 'stat-graph-realtime',
      component: StatGraphRealtimeComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/stat/overview',
      name: 'stat-overview',
      component: StatOverviewComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/stat/summarize',
      name: 'stat-summarize',
      component: StatSummarizeComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/annotation/settings',
      name: 'annotation-settings',
      component: AnnotationComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/annotation/form',
      name: 'annotation-form',
      component: AnnotationFormComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/full-views/weaving-machine/statistics',
      name: 'full-views-weaving-machine-statistics',
      component: WeavingMachineStatisticComponent,
      meta: {
        layout: 'FullView',
      },
    },
    {
      path: '/full-views/stat/overview',
      name: 'full-views-stat-overview',
      component: StatOverviewComponent,
      meta: {
        layout: 'FullView',
      },
    },
    {
      path: '/machine',
      name: 'machine',
      component: MachineComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/datacontroller',
      name: 'datacontroller',
      component: MicrocontrollerComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/manage/user',
      name: 'user',
      component: UserComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/manage/group',
      name: 'group',
      component: GroupComponent,
      meta: {
        layout: 'Backend',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        layout: 'Default',
      },
    },
    {
      path: '*',
      name: '404',
      component: PageNotFound,
      meta: {
        layout: 'Default',
      },
    },
  ],
});
